/* eslint-disable react/no-unescaped-entities */
import React from "react";
import LegalLayout, { H2, H3, P, Ul } from "./LegalLayout";
import Seo from "../Seo";

const CONTROLLER_EMAIL = "privacy@mydigitalaction.it";

export default function CookiePolicyPage() {
  return (
    <LegalLayout title="Cookie Policy" kicker="Utilizzo di cookie e tracker" lastUpdated="Febbraio 2026">
      <Seo title="Cookie Policy — MyDigitalAction" description="Informativa sull'utilizzo di cookie e tracker sul sito mydigitalaction.it." path="/cookie-policy" />
      <P>
        Questa Cookie Policy descrive l'utilizzo di cookie e altri strumenti di tracciamento sul sito
        {" "}<strong className="text-white">mydigitalaction.it</strong>{" "}(di seguito &laquo;Sito&raquo;), in conformit&agrave;
        al GDPR (Regolamento UE 2016/679), alla Direttiva ePrivacy 2002/58/CE e alle Linee Guida del Garante Italiano per la
        Protezione dei Dati Personali (provvedimento 10 giugno 2021).
      </P>

      <H2>Cosa sono i cookie</H2>
      <P>
        I cookie sono piccoli file di testo che i siti visitati inviano al terminale (computer, tablet, smartphone) dell'Utente,
        dove vengono memorizzati per essere ritrasmessi agli stessi siti alla successiva visita. I cookie possono avere finalit&agrave;
        tecniche (indispensabili al funzionamento del Sito) o non tecniche (statistiche, profilazione, marketing).
      </P>

      <H2>Tipologie di cookie utilizzati</H2>

      <H3>1. Cookie tecnici (sempre attivi)</H3>
      <P>
        Sono cookie strettamente necessari al funzionamento del Sito e all'erogazione dei servizi richiesti dall'Utente. Non
        richiedono il consenso dell'Utente in base all'art. 122 del Codice Privacy italiano.
      </P>
      <Ul>
        <li><strong className="text-white/90">Sessione admin</strong> (sessionStorage): mantiene la sessione admin loggata (`mda_admin_token`), scade alla chiusura del browser.</li>
        <li><strong className="text-white/90">Cloudflare</strong> (cf_bm, cf_clearance): protezione anti-bot e sicurezza CDN, durata massima 30 minuti.</li>
        <li><strong className="text-white/90">Stripe</strong> (__stripe_mid, __stripe_sid): utilizzati nella pagina di pagamento embedded per la prevenzione delle frodi, durata sessione.</li>
      </Ul>

      <H3>2. Cookie analitici anonimi (attivi previo consenso base)</H3>
      <P>
        Questi cookie raccolgono informazioni statistiche in forma aggregata e anonimizzata sull'utilizzo del Sito,
        permettendo al Titolare di comprendere come gli Utenti interagiscono con i contenuti. Nessun dato personale
        identificabile viene condiviso con terzi.
      </P>
      <Ul>
        <li><strong className="text-white/90">Google Analytics 4</strong> &mdash; Fornitore: Google Ireland Ltd. (UE). Measurement ID <code style={{color:'#d4ff3d'}}>G-E5PRVTD5VQ</code>. Configurato con Consent Mode v2, anonimizzazione IP, allow_google_signals disattivato. Cookie <code>_ga</code>, <code>_ga_*</code>, durata 2 anni. Attivo solo dopo consenso analitico.</li>
        <li><strong className="text-white/90">Google Tag Manager</strong> &mdash; Container ID <code style={{color:'#d4ff3d'}}>GTM-MJ78KCSF</code>. Non deposita cookie propri, orchestrata altri tag previo consenso.</li>
        <li>Se in futuro verranno integrati altri servizi (es. Meta Pixel), questa policy sar&agrave; aggiornata prima dell&apos;attivazione.</li>
      </Ul>

      <H3>3. Cookie di marketing e profilazione (attivi solo con consenso esplicito)</H3>
      <P>
        Questi cookie sono utilizzati per profilare l'Utente e mostrare pubblicit&agrave; personalizzate su questo Sito o su
        piattaforme di terzi. Vengono attivati solo se l'Utente presta esplicito consenso attraverso il banner cookie.
      </P>
      <Ul>
        <li>Al momento questa Applicazione <strong className="text-white/90">non utilizza cookie di marketing</strong>.</li>
        <li>In caso di futura integrazione con Meta Pixel, Google Ads o simili, tali cookie verranno attivati solo previo consenso esplicito.</li>
      </Ul>

      <H2>Servizi terzi utilizzati</H2>
      <P>
        Alcuni servizi integrati nel Sito possono impostare cookie autonomamente per svolgere la loro funzione. L'elenco
        completo dei fornitori terzi &egrave; disponibile nella nostra{" "}
        <a href="/privacy-policy" style={{ color: "#d4ff3d" }}>Privacy Policy</a>.
      </P>
      <Ul>
        <li><strong className="text-white/90">Cloudflare</strong>: cookie tecnici di sicurezza e distribuzione CDN.</li>
        <li><strong className="text-white/90">Stripe</strong>: cookie tecnici per il processo di pagamento e la prevenzione frodi (attivati solo sulla pagina /checkout/pagamento).</li>
        <li><strong className="text-white/90">Cal.com</strong>: cookie tecnici caricati nel widget di prenotazione quando l'Utente lo apre.</li>
        <li><strong className="text-white/90">WhatsApp / Meta</strong>: cookie caricati dal widget WhatsApp quando l'Utente clicca sul pulsante flottante.</li>
      </Ul>

      <H2>Come gestire i cookie</H2>
      <P>
        L'Utente pu&ograve; in qualsiasi momento gestire le proprie preferenze relative ai cookie:
      </P>
      <Ul>
        <li><strong className="text-white/90">Dal banner cookie</strong> presente al primo accesso al Sito (una volta implementato).</li>
        <li><strong className="text-white/90">Dalle impostazioni del browser</strong>: la maggior parte dei browser permette di bloccare o eliminare i cookie. Consulta la documentazione del tuo browser:
          <Ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer noopener" style={{ color: "#d4ff3d" }}>Chrome</a></li>
            <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noreferrer noopener" style={{ color: "#d4ff3d" }}>Firefox</a></li>
            <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer noopener" style={{ color: "#d4ff3d" }}>Safari</a></li>
            <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noreferrer noopener" style={{ color: "#d4ff3d" }}>Edge</a></li>
          </Ul>
        </li>
      </Ul>
      <P>
        La disabilitazione dei cookie tecnici pu&ograve; compromettere il corretto funzionamento del Sito.
      </P>

      <H2>Contatti</H2>
      <P>
        Per qualsiasi domanda relativa all'uso dei cookie, puoi contattare il Titolare all'indirizzo{" "}
        <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#d4ff3d" }}>{CONTROLLER_EMAIL}</a>.
      </P>
    </LegalLayout>
  );
}
